module.exports = __webpack_public_path__ + "static/media/level-6.f5d2ccc8.png";